// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__1CY03","ranges":"BmiRanges_ranges__4rlg0"};